import React, { useEffect, useState } from 'react';
import { CustomOverlay } from './NaverCustom';

const initMap = (domId, defaultOption = {}) => {
  let center = { lat: 37.659101, lng: 127.059603 };
  let zoom = 15;

  let defaultCenter = defaultOption.center;
  if (defaultCenter && defaultCenter.latitude && defaultCenter.longitude)
    center = { lat: defaultCenter.latitude, lng: defaultCenter.longitude };
  if (defaultOption && defaultOption.zoom)
    zoom = defaultOption.zoom;

  const naver = window.naver;
  const _map = new naver.maps.Map(domId, {
    zoomControl: true,
    zoomControlOptions: {
      style: naver.maps.ZoomControlStyle.SMALL,
      position: naver.maps.Position.RIGHT_BOTTOM
    },
    mapTypeControl: false,
    keyboardShortcuts: false,
    center,
    zoom
  });

  /* CUSTOM */
  _map.moveTo = function (coords) {
    if (!coords || !coords.y || !coords.x) return;
    setTimeout(() => {
      this.panTo(new naver.maps.LatLng(coords.y, coords.x));
    }, 100);
  };

  return _map;
};

const initDrawingManager = (map, options = {}) => {
  const naver = window.naver;
  const drawingManager = new naver.maps.drawing.DrawingManager({
    map: map,
    drawingControl: [
      naver.maps.drawing.DrawingMode.HAND,
      naver.maps.drawing.DrawingMode.RECTANGLE,
      naver.maps.drawing.DrawingMode.ELLIPSE,
      naver.maps.drawing.DrawingMode.POLYLINE,
      naver.maps.drawing.DrawingMode.ARROWLINE,
      naver.maps.drawing.DrawingMode.POLYGON,
      naver.maps.drawing.DrawingMode.MARKER
    ],
    drawingControlOptions: {
      position: naver.maps.Position.TOP_CENTER,
      style: naver.maps.drawing.DrawingStyle.HORIZONTAL
    },
    polygonOptions: {
      // fillColor: '#ffc300',
      fillColor: "blue",
      fillOpacity: 0.1,
      strokeWeight: 4,
      // strokeColor: '#ffc300',
      strokeColor: "blue"
    }
  });

  drawingManager.addListener(naver.maps.drawing.DrawingEvents.ADD, (overlay) => {
    const boundary = overlay.paths.getArray()[0].getArray().map(latlng => ({ x: latlng.x, y: latlng.y }));
    options.onCreateOverlay && options.onCreateOverlay({ id: overlay.id, boundary, origin: overlay });
  });
  drawingManager.addListener(naver.maps.drawing.DrawingEvents.REMOVE, (overlay) => {
    const boundary = overlay.paths.getArray()[0].getArray().map(latlng => ({ x: latlng.x, y: latlng.y }));
    options.onDeleteOverlay && options.onDeleteOverlay({ id: overlay.id, boundary });
  });
};

const NaverMap = (props) => {
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState([]);
  const [polygons, setPolygons] = useState([]);
  const [customOverlays, setCustomOverlays] = useState([]);

  useEffect(() => {
    const _map = initMap("naver-map", props.default);
    const naver = window.naver;
    naver.maps.Event.once(_map, 'init', () => {
      setMap(_map);
      props.onInit && props.onInit(_map);
    });
    naver.maps.Event.addListener(_map, 'idle', (e) => {
      props.onIdle && props.onIdle(e, _map);
    });
    naver.maps.Event.addListener(_map, 'click', (e) => {
      props.onClick && props.onClick(e, _map);
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!map) return;
    props.useDrawingManager && initDrawingManager(map, props);
    // eslint-disable-next-line
  }, [map, props.useDrawingManager]);

  useEffect(() => {
    if (!map) return;
    polygons.forEach(v => v.setMap(null));
    props.polygons && setPolygons(mapToPolygons(map, props.polygons));
    // eslint-disable-next-line
  }, [map, props.polygons]);

  useEffect(() => {
    if (!map) return;
    customOverlays.forEach(v => v.setMap(null));
    setCustomOverlays(mapToCustomOverlays(map, props.customOverlays));
    // eslint-disable-next-line
  }, [map, props.customOverlays]);

  useEffect(() => {
    if (!map) return;
    markers.forEach(o => o.setMap(null));
    setMarkers(mapToMarkers(map, props.markers));
    // eslint-disable-next-line
  }, [map, props.markers]);

  const mapToPolygons = (map, polygons = []) => {
    const naver = window.naver;
    return polygons.map(polygon => new naver.maps.Polygon({
      map: map,
      paths: [polygon.boundary.map(v => new naver.maps.LatLng(v.y, v.x))],
      fillColor: '#ff0000',
      fillOpacity: 0.3,
      strokeColor: '#ff0000',
      strokeOpacity: 0.6,
      strokeWeight: 3,
      ...polygon.option
    }));
  }

  const mapToCustomOverlays = (map, customOverlays = []) => {
    const naver = window.naver;
    return customOverlays.map(v => new CustomOverlay({
      map,
      element: v.element,
      position: new naver.maps.LatLng(v.latitude, v.longitude),
      dataset: v
    }));
  };

  const mapToMarkers = (map, markers = []) => {
    const naver = window.naver;
    return markers.map(v => {
      const _marker = new naver.maps.Marker({
        map,
        icon: v.icon,
        position: new naver.maps.LatLng(v.latitude, v.longitude),
        dataset: v
      });
      naver.maps.Event.addListener(_marker, 'click', v.onClick);
      return _marker;
    });
  };

  return (<>
    <div id={"naver-map"} style={{ width: "100%", height: props.height ? props.height : window.innerHeight, ...props.style }}></div>
  </>);
}

export { NaverMap };
